module.exports = __webpack_public_path__ + "img/shopify.d6fe5191.png";